/**
 * return seconds
 */
export function tsV4()
{
	return Math.floor(Date.now() / 1000)
}
